import React from 'react';
import { CollectionCharacterCard } from './CollectionCharacterCard';
import { cn } from '@/lib/utils';
import { ICharacter } from '@/models/characters';
import { ICharacterUnlockedImages } from '@/models/image';

type Props = {
  characters: ICharacter[];
  imageSummaries: ICharacterUnlockedImages;
};

export const CollectionCharacterList: React.FC<Props> = ({ characters, imageSummaries }) => {
  return (
    <div
      className={cn(
        'grid h-fit w-full grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-[12px]',
      )}
    >
      {characters && characters.map((char, i) => (
        <CollectionCharacterCard key={char.id} 
        character={char} 
        imageCount={imageSummaries[char.id]?.image_count || 0} 
        />
      ))}
    </div>
  );
};
